/**
 * @file outfitterSlice.js
 * @description Sets initial state for the warehouse module.  Creates reducers and actions for API Calls
 * @author Ben Yee
 */
import { createSlice } from '@reduxjs/toolkit';
import undoable from 'redux-undo';
import { logger } from 'utils/logger';

const settingsSlice = createSlice({
    name: 'settings',
    initialState: {
        theme: 'dark',
        keywordHighlighting:true,
        error: null,
        success: null,
        loading: false,
        action: null,
    },
    reducers: {
        setTheme(state, action) {
            state.theme = action.payload;
        },
        setKeywordHighlighting(state, action) {
          logger.log('setting keyword highlight', action.payload)
            state.keywordHighlighting = action.payload;
        },
    },
});

export const { selectSample, setTheme, setKeywordHighlighting } = settingsSlice.actions;

export default settingsSlice.reducer;

// export default undoable(settingsSlice.reducer, {
//     limit: 20, // set a limit for the size of the history
// });
